const columns = [{
    title: 'Voucher',
    searchName: "voucher",
    dataIndex: 'voucher',
    key: 'voucher',
    width: '20%',
    sortKind: "string"
}, {
    title: 'Data Inicio',
    searchName: "data inicio",
    dataIndex: 'beginDate',
    key: 'beginDate',
    width: '20%',
    sortKind: "string"
},{
    title: 'Data Final',
    searchName: "data final",
    dataIndex: 'endDate',
    key: 'endDate',
    width: '20%'
},{
    title: 'Sala',
    searchName: "sala",
    dataIndex: 'room',
    key: 'room',
    width: '15%',
    sortKind: "string"
},{
    title: 'Filial',
    searchName: "filial",
    dataIndex: 'branch',
    key: 'branch',
    width: '15%',
    sortKind: "string"
},{
    title: 'Ação',
    dataIndex: 'uf',
    key: 'action',
    width: '10%'
}];

export default columns;


// WEBPACK FOOTER //
// ./src/const/columns/vouchers.js